<template>
  <b-container>
    <m-posts-300 :flatCategoriesShape="true" :paginate="true" :category-panel="true"/>
  </b-container>
</template>

<script>
export default {
  name: "Posts"
}
</script>

<style>
.categories-panel-300-z-index {
  position: relative !important;
}
</style>

<style scoped>

</style>